import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
// Your web app's Firebase configuration
var FirebaseConfig = {
    apiKey: process.env.FIREBASE_API_KEY || '',
    authDomain: process.env.FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.FIREBASE_APP_ID || '',
};
// Initialize Firebase App
var firebaseApp = initializeApp(FirebaseConfig);
var firebaseDb = getFirestore(firebaseApp);
export { firebaseApp, firebaseDb };
// // Initialize Firebase
// const database = firebase.database();
// // Create a session
// const sessionId = 'mySession';
// const sessionRef = database.ref(`sessions/${sessionId}`);
// // Join a session
// sessionRef.on('value', (snapshot) => {
//   const sessionData = snapshot.val();
//   // Update the map based on sessionData.mapData
// });
// // Add a marker
// function addMarker(coordinates) {
//   const newMarker = {
//     // ... marker data
//   };
//   sessionRef.child('mapData').child('markers').push(newMarker);
// }
// // Listen for marker updates
// sessionRef.child('mapData').child('markers').on('child_added', (snapshot) => {
//   const markerData = snapshot.val();
//   // Add the marker to the map
// });
